import Block from '../block'

export default class BlockMusic extends Block {
	static title = 'block-music'

	constructor($el) {
		super($el)

		this.iframe = this.$el.find('.block-music__iframe')
		this.form = this.$el.find('.block-music__cookies')
		this.icon = this.$el.find('.block-music__icon')

		if (this.form) {
			this.form.on('submit', (e) => {
				e.preventDefault()

				this.submitForm()
			})
		}

		$(document).on('blockmusic:load', () => {
			this.iframe.html(this.$el.data('embed'))
			this.iframe.addClass('block-music__iframe--embed')
		})
	}

	submitForm() {
		this.setLoading(true)
		const data = new FormData()
		data.set('ajax', true)
		data.set('cookie', 'music_block')

		$.ajax({
			method: 'POST',
			processData: false,
			contentType: false,
			cache: false,
			url: '/_api/cookie',
			data: data,
		})
			.done(() => {
				$(document).trigger('blockmusic:load')

				this.setLoading(false)
				$(document).trigger('message:success', {
					message: this.$el.data('success'),
				})
			})
			.fail(() => {
				$(document).trigger('message:error', {
					message: this.$el.data('failed'),
				})
			})
	}

	setLoading(bool) {
		if (bool) {
			this.form.find('button[type="submit"]').prop('disabled', true)
			this.icon.addClass('fa-spinner fa-spin')
			this.icon.removeClass('fa-cookie')
		} else {
			this.form.find('button[type="submit"]').prop('disabled', false)
			this.icon.addClass('fa-cookie')
			this.icon.removeClass('fa-spinner fa-spin')
		}
	}
}
